export const replaceSubStrings = (actualString: string, subString: string, replaceWith=''): string => {
    return actualString.replace(new RegExp(subString, 'g'), replaceWith);
}
